// extracted by mini-css-extract-plugin
export default {"addButton":"AddBrand_addButton__p5kP7","dialog":"AddBrand_dialog__EQYYV","dialogContent":"AddBrand_dialogContent__fOGY-","dialogFooter":"AddBrand_dialogFooter__8Eiw1"};